import React, { useState } from 'react'
import PropTypes from 'prop-types'
import _, { isEmpty } from 'lodash'
import { Button, Col, Form, Icon, Input, Modal, Select, Row, Upload } from 'antd'
import { FormItem } from '../../../../styles/shared.style'
import { ButtonEx } from '../../../../styles/button.style'
import { useDeepEffect } from '../../../../utils/hooks'
import { beforeUpload, compressFile, getBase64 } from '../../../../utils/services'
import { selectRule } from '../../../../utils/rules'
import { REWARD_CATAGORY } from '../../../../utils/constants'
import axios from 'axios'

const RewardForm = (props) => {
  const { visible, onOk, onCancel, formData, form } = props
  const { getFieldDecorator, validateFields, setFieldsValue } = form
  const [imageUrl, setImageUrl] = useState('')
  const [file, setFile] = useState(null)

  useDeepEffect(() => {
    if (!isEmpty(formData)) {
      setFieldsValue({
        name: formData.name,
        detail: formData.detail,
        redeemPoint: formData.redeemPoint,
        availableAmount: formData.availableAmount,
        catagories: formData.catagories
      })
      setImageUrl(formData.image)
    }

    return () => {
      form.resetFields()
      setImageUrl('')
      setFile(null)
    }
  }, [formData])

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          name: values.name,
          detail: values.detail,
          redeemPoint: values.redeemPoint,
          availableAmount: values.availableAmount,
          catagories: values.catagories
        }
        if (values.image) {
          try {
            const formImgData = new FormData()
            if (!_.isNull(values.image.file)) {
              formImgData.append('image', await compressFile(values.image.file))
              const res = await axios.post(
                process.env.REACT_APP_API_ENDPOINT + `/reward/image`,
                formImgData,
                {
                  headers: {
                    'content-type': 'multipart/form-data'
                  }
                }
              )
              data.image = res.data.url
            }
          } catch (err) {
            console.log(err)
          }
        }else{
          data.image = formData.image
        }

        if (!_.isEmpty(formData)) {
          data.id = formData.id
        }
        onOk(data)
      }
    })
  }
  async function handleChange(info) {
    await getBase64(info.file, (imageUrl) => {
      setImageUrl(imageUrl)
    })
  }

  const uploadButton = (
    <div>
      <Icon type="plus" />
      <div className="ant-upload-text">Upload</div>
    </div>
  )

  return (
    <Modal
      title={`${!_.isEmpty(formData) ? 'Edit' : 'Create'} a News`}
      visible={visible}
      footer={null}
      onCancel={onCancel}>
      <Form form={form} onSubmit={onSubmit} layout="vertical">
        <Form.Item label="ชื่อรางวัล">
          {getFieldDecorator(`name`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input
            name="name"
            placeholder="ชื่อรางวัล" />)}
        </Form.Item>
        <Form.Item label="รายละเอียด">
          {getFieldDecorator(`detail`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input.TextArea
            name="detail"
            placeholder="รายละเอียด" />)}
        </Form.Item>
        <FormItem label="รูปรางวัล">
          {getFieldDecorator(`image`, {
            rules: [
              {
                required: _.isEmpty(formData),
                message: 'กรุณาเลือก'
              }
            ]
          })(
            <Upload
            name="img"
            listType="picture-card"
            showUploadList={false}
            beforeUpload={(file) => beforeUpload(file)}
            onChange={handleChange}>
            {imageUrl ? (
              <img src={imageUrl} alt="img" style={{ width: '100%' }} />
            ) : (
              uploadButton
            )}
          </Upload>
          )}
        </FormItem>
        <Form.Item label="คะแนนที่ใช้แลก">
          {getFieldDecorator(`redeemPoint`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input type="number"
            name="redeemPoint"
            placeholder="คะแนนที่ใช้แลก" />)}
        </Form.Item>
        <Form.Item label="จำนวนของรางวัล">
          {getFieldDecorator(`availableAmount`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input type="number"
            name="availableAmount"
            placeholder="จำนวนของรางวัล" />)}
        </Form.Item>
        <Form.Item label="ประเภทของรางวัล">
        {getFieldDecorator(`catagories`, { ...selectRule })(
          <Select placeholder="เลือกประเภทของรางวัล">
            {REWARD_CATAGORY &&
              REWARD_CATAGORY.map((catagories) => (
                <Select.Option key={catagories}>{catagories}</Select.Option>
              ))}
          </Select>
        )}
      </Form.Item>
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>ยกเลิก</Button>
          </Col>
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
              บันทึก
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

RewardForm.propTypes = {
  form: PropTypes.any,
  visible: PropTypes.bool.isRequired,
  formData: PropTypes.object.isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}

const WrappedRewardForm = Form.create({ name: 'RewardForm' })(
  RewardForm
)
export default WrappedRewardForm



// WEBPACK FOOTER //
// ./src/pages/Reward/components/RewardForm/index.js